module.exports = __webpack_public_path__ + "img/university-logo.c20f6121.svg";